import script from "./ProductInfoSp.vue?vue&type=script&setup=true&lang=js"
export * from "./ProductInfoSp.vue?vue&type=script&setup=true&lang=js"

import "./ProductInfoSp.vue?vue&type=style&index=0&id=a78c0d62&lang=scss&scoped=true"

import exportComponent from "/builds/frontend/linjie/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a78c0d62"]])

export default __exports__